package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.SubscriptionPlanRepository
import com.clany.backoffice.model.SubscriptionPlanResponse
import dev.zacsweers.metro.Inject

@Inject
class UpdateSubscriptionPlanUseCase(
    private val repository: SubscriptionPlanRepository
) {
    suspend operator fun invoke(id: String, plan: SubscriptionPlanResponse): Result<Unit> =
        repository.updateSubscriptionPlan(id, plan)
}
